var render = function () {
  var _vm$currentRound$left, _vm$currentRound$cent;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.currentRound ? _c('section', {
    staticClass: "activity-stage quotebubble"
  }, [_c('aside', {
    staticClass: "activity-side-image"
  }, [_c('figure', [_c('img', {
    attrs: {
      "src": (_vm$currentRound$left = _vm.currentRound.leftImage) === null || _vm$currentRound$left === void 0 ? void 0 : _vm$currentRound$left.image.src
    }
  })])]), _c('section', {
    staticClass: "activity-content-container"
  }, [_c('header', {
    staticClass: "activity-header-quote"
  }, [_c('text-display-list', [_c('li', {
    staticClass: "quote-bubble-container",
    class: {
      isMobileView: _vm.isMobile
    }
  }, [_c('div', {
    style: _vm.quoteBubbleImage
  }, [_c('blinking-cursor-text', {
    attrs: {
      "text": _vm.currentRound.quote,
      "text-step": 0
    }
  })], 1)])])], 1), _c('div', {
    staticClass: "activity-subheader"
  }, [_c('text-display-list', {
    staticClass: "subheader-words"
  }, [_c('li', [_c('h3', [_vm._v("English Word:")]), _c('blinking-cursor-text', {
    attrs: {
      "text": _vm.currentRound.word,
      "text-step": 1
    }
  })], 1), _c('li', [_c('h3', [_vm._v("Meaning:")]), _c('blinking-cursor-text', {
    attrs: {
      "text": _vm.currentRound.meaning,
      "text-step": 2
    }
  })], 1)])], 1), _c('div', {
    staticClass: "activity-paragraph"
  }, [_c('figure', [_c('img', {
    style: {
      height: 'auto',
      width: _vm.isMobile ? '75px' : '150px'
    },
    attrs: {
      "src": (_vm$currentRound$cent = _vm.currentRound.centerImage) === null || _vm$currentRound$cent === void 0 ? void 0 : _vm$currentRound$cent.image.src
    }
  })]), _c('blinking-cursor-text', {
    attrs: {
      "text": _vm.currentRound.paragraph,
      "text-step": 3
    }
  })], 1)])]) : _vm._e(), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }